import { useTheme } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import LOGO_DARK from "../../../images/icons/neutral_edit/logo_dark.svg";
import LOGO_LIGHT from "../../../images/icons/neutral_edit/logo_light.svg";

type LogPropsType = {};

export const Logo = (props: LogPropsType) => {
  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme();

  const LOGO = theme.palette.mode === "dark" ? LOGO_DARK : LOGO_LIGHT;

  const onClick = () => {
    const search = sessionStorage.getItem("search");

    if (search) {
      const params = new URLSearchParams(search);
      navigate(`/?${params.toString()}`);
    } else {
      navigate("/");
    }
  };

  return (
    <img
      src={LOGO}
      className="hover-cursor"
      style={{ height: "40px", borderBottom: "1px solid rgb(67, 67, 72)" }}
      onClick={() => {
        onClick();
      }}
      alt=""
    />
  );
};
